import { render, staticRenderFns } from "./AdmAcessUserView.vue?vue&type=template&id=12789a78&scoped=true"
import script from "./AdmAcessUserView.vue?vue&type=script&lang=js"
export * from "./AdmAcessUserView.vue?vue&type=script&lang=js"
import style0 from "./AdmAcessUserView.vue?vue&type=style&index=0&id=12789a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12789a78",
  null
  
)

export default component.exports